import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  secondaryColor: PropTypes.string,
  size: PropTypes.number,
};

const VerifiedIcon = ({ color = '#0c84fd', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.458 9.104c.583.458.583 1.334.04 1.77l-.915.71c-.395.31-.54.853-.354 1.31l.437 1.064c.27.687-.167 1.437-.896 1.542l-1.145.145c-.5.063-.896.46-.96.96l-.144 1.145c-.103.73-.853 1.167-1.54.896l-1.063-.438c-.46-.188-1-.042-1.313.354l-.708.916c-.438.584-1.333.584-1.77 0l-.71-.916c-.31-.396-.853-.54-1.312-.354l-1.062.438c-.687.27-1.438-.167-1.542-.896l-.145-1.146c-.063-.5-.46-.896-.96-.96L2.25 15.5c-.73-.105-1.167-.854-.896-1.542l.458-1.062c.188-.458.042-1-.354-1.312l-.936-.688c-.584-.438-.584-1.333 0-1.77l.916-.71c.395-.31.54-.853.354-1.312l-.438-1.062c-.27-.687.167-1.438.896-1.542l1.146-.145c.5-.063.896-.46.96-.96L4.5 2.25c.104-.73.854-1.167 1.542-.896l1.062.458c.458.188 1 .042 1.312-.354L9.084.52c.437-.583 1.333-.583 1.77 0l.708.917c.313.396.855.54 1.313.354l1.063-.437c.687-.27 1.437.167 1.54.896l.147 1.145c.063.5.46.896.96.96l1.144.144c.73.104 1.166.853.895 1.54l-.437 1.064c-.188.458-.042 1 .354 1.312l.916.688zm-5.854-.23c.417-.415.417-1.103 0-1.52-.416-.416-1.104-.416-1.52 0l-3.043 3-1.124-1.125c-.416-.418-1.104-.418-1.52 0-.417.415-.417 1.103 0 1.52l1.896 1.896c.208.208.48.312.77.312.292 0 .563-.104.77-.312l3.772-3.77z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

VerifiedIcon.propTypes = propTypes;

export default VerifiedIcon;
